import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Button } from "../../../../components/ui/button";
import { MobileNav } from "../../../../components/MobileNav/MobileNav";
import { MAIN_NAV_ITEMS } from "../../../../lib/siteNav";
import { cn } from "../../../../lib/utils";

export const HeaderSection = (): JSX.Element => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  const isActive = (href: string) =>
    pathname === href || (href !== "/" && pathname.startsWith(`${href}/`));

  return (
    <>
      <header className="site-header sticky top-0 left-0 z-50 flex w-full h-16 md:h-[100px] items-center justify-between px-4 md:px-8 bg-white/90 dark:bg-gray-950/90 backdrop-blur-sm border-b border-[#e3e4e4] dark:border-gray-800">
        <Link
          to="/"
          className="site-header__brand flex items-center h-full py-3 md:py-5 shrink-0 hover:opacity-90 transition-opacity duration-200"
        >
          <img
            src="/image-1.png"
            alt="UX Michal"
            width={174}
            height={60}
            className="site-logo h-[44px] md:h-[60px] w-auto max-w-[174px] object-contain object-left"
            decoding="async"
          />
        </Link>

        <nav className="site-header__nav hidden lg:flex h-full items-center" aria-label="Main navigation">
          <ul className="flex h-full items-center gap-1">
            {MAIN_NAV_ITEMS.map((item) => (
              <li key={item.id} className="h-full">
                <Link
                  to={item.href}
                  className={cn(
                    "flex h-full items-center px-5 xl:px-6 hover:text-wwwuxmichalcomdodger-blue transition-colors duration-200",
                    isActive(item.href) && "text-wwwuxmichalcomdodger-blue",
                  )}
                >
                  <span className="font-www-uxmichal-com-montserrat-semibold-upper text-wwwuxmichalcomblack text-[13px] xl:text-[15px] font-medium tracking-wider leading-[var(--www-uxmichal-com-montserrat-semibold-upper-line-height)] whitespace-nowrap">
                    {item.label}
                  </span>
                </Link>
              </li>
            ))}
            <li className="ml-2 xl:ml-4 flex h-full items-center">
              <Button
                asChild
                className="site-header__cta !h-auto min-h-10 self-center shrink-0 bg-wwwuxmichalcomdodger-blue hover:bg-blue-600 transition-colors duration-200 text-white text-[13px] xl:text-[15px] font-medium normal-case tracking-normal px-5 xl:px-6 py-2.5 rounded-lg"
              >
                <Link to="/contact">Start Project</Link>
              </Button>
            </li>
          </ul>
        </nav>

        <button
          type="button"
          onClick={() => setMobileOpen(true)}
          className="site-header__menu-btn lg:hidden flex items-center justify-center w-12 h-12 -mr-2 border-l border-[#e3e4e4] dark:border-gray-800 text-gray-900 dark:text-gray-100 hover:bg-blue-50 dark:hover:bg-gray-800 transition-colors"
          aria-expanded={mobileOpen}
          aria-label="Open menu"
        >
          <Menu className="w-6 h-6" strokeWidth={2} />
        </button>
      </header>

      <MobileNav open={mobileOpen} onClose={() => setMobileOpen(false)} items={MAIN_NAV_ITEMS} />
    </>
  );
};
